import React, { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export default function Input({
    children,
    col = 6,
    label,
    placeholder,
    type = 'text',
    mode = 'text',
    isLTR = false,
    hasIcon = false,
    onChange,
    value,
    required,
    ...attributes
}) {

    const [dataValue, setDataValue] = useState('');
    const { t } = useTranslation();
    const dataProps = useMemo(() => JSON.stringify({value, required, label}), [label, required, value]);

    useEffect(() => {
        setDataValue(value ?? '');
    }, [value]);

    function changeText(value) {
        setDataValue(value);
    }
    function setValue() {
        onChange(dataValue);
    }

    return (
        <div
            className={`col-${col}`}
            // data-props={dataProps}
            data-props={t(dataProps)}
        >
            {
                label &&
                <div className='mt20 mb5'>
                    <label>
                        {
                            required &&
                            <span style={{color: 'red'}}>* </span>
                        }
                        { label }
                    </label>
                </div>
            }
            <div className={`input-parent ${isLTR ? '' : 'rtl'} ${hasIcon ? 'withIcon' : ''}`}>
                <input
                    {...attributes}
                    type={type}
                    inputMode={mode}
                    value={dataValue}
                    placeholder={placeholder || label}
                    onChange={e => changeText(e.target.value)}
                    onBlur={setValue}
                    required={required}
                />
                {children}
            </div>
        </div>
    );

}
